import { AloBase, getDefaultAloBase } from './AloBase'
import { AloMedia, cleanAloMedia, getDefaultAloMedia } from './AloMedia'


export interface AloMns extends AloBase {                    
    usrNom: string
    usrPrenom: string
    ctyName: string
    image:AloMedia
}

export const getDefaultAloMns = ():AloMns => {
    return {  
        ...getDefaultAloBase(),                
        usrNom:"",
        usrPrenom:"",        
        ctyName:"",
        image:getDefaultAloMedia()
    }
}


export const cleanAloMns = (mns:AloMns) => {
    if(!mns) return    
    if(!mns.id) delete mns.id
    cleanAloMedia(mns.image)
}

